// src/pages/ProverbsDaily.js
import React, { useState, useEffect } from 'react';
import { startOfDay } from 'date-fns';
import Header from '../components/layout/Header';
import DateNavigator from '../components/DateNavigator';
import AuthorSection from '../components/AuthorSection';
import EmailSubscription from '../components/EmailSubscription';
import DevotionalHomePage from './DevotionalHomePage';

const ProverbsDaily = () => {
  // Create initial date based on user's local timezone
  const createInitialDate = () => {
    // Start with current date in user's timezone
    const now = new Date();
    // Use the actual current date (no longer forcing to 2025)
    const startOfDayDate = startOfDay(now);

    console.log('Initial date created:', {
      localDate: startOfDayDate.toLocaleString(),
      isoString: startOfDayDate.toISOString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });

    return startOfDayDate;
  };

  const [currentDate, setCurrentDate] = useState(createInitialDate);

  // Set boundaries for navigation - using local timezone dates
  const MIN_DATE = startOfDay(new Date(2025, 0, 1)); // January 1, 2025
  const MAX_DATE = startOfDay(new Date(2026, 11, 31)); // December 31, 2026

  // Effect to verify the current date on mount and after any changes
  useEffect(() => {
    console.log('Current date:', {
      localDate: currentDate.toLocaleString(),
      isoString: currentDate.toISOString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      date: currentDate.getDate(),
      month: currentDate.getMonth() + 1
    });
  }, [currentDate]);

  const handleDateChange = (newDate) => {
    // Keep the date in local timezone but ensure it's start of day
    const updatedDate = startOfDay(newDate);

    if (updatedDate >= MIN_DATE && updatedDate <= MAX_DATE) {
      console.log('Date changed to:', {
        localDate: updatedDate.toLocaleString(),
        isoString: updatedDate.toISOString()
      });
      setCurrentDate(updatedDate);
    }
  };

  const isDateDisabled = (date) => {
    // Compare dates in local timezone
    const compareDate = startOfDay(date);
    return compareDate < MIN_DATE || compareDate > MAX_DATE;
  };

  return (
    <div className="w-full">
      <Header currentDate={currentDate} />
      <DateNavigator
        currentDate={currentDate}
        onDateChange={handleDateChange}
        isDateDisabled={isDateDisabled}
        minDate={MIN_DATE}
        maxDate={MAX_DATE}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-2 space-y-4">
        <DevotionalHomePage currentDate={currentDate} />
        <AuthorSection />
        <EmailSubscription />
      </div>
    </div>
  );
};

export default ProverbsDaily;